module.exports = __webpack_public_path__ + "3_Student_Dashboard-1fb9f6e3b66ce621aff38b3f570e4d60.jpg";